// removed by extract-text-webpack-plugin
module.exports = {"paragraph":"Paragraph--paragraph--PZ4LB"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/Paragraph/Paragraph.css
// module id = 1026
// module chunks = 0